/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * Commercial - API
 * OpenAPI spec version: 4.12.3
 */
export interface AdminDto {
  gender: Gender;
  firstName: string;
  lastName: string;
  emailBusiness: string;
  mobile: string;
}

export type AnnualFlightSpending = typeof AnnualFlightSpending[keyof typeof AnnualFlightSpending];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnualFlightSpending = {
  LESS_THAN_10: 'LESS_THAN_10',
  BETWEEN_10_AND_100: 'BETWEEN_10_AND_100',
  BETWEEN_100_AND_200: 'BETWEEN_100_AND_200',
  OVER_200: 'OVER_200',
} as const;

export type AnnualGrossIncome = typeof AnnualGrossIncome[keyof typeof AnnualGrossIncome];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnualGrossIncome = {
  LESS_THAN_50_000: 'LESS_THAN_50_000',
  BETWEEN_50_000_AND_100_0000: 'BETWEEN_50_000_AND_100_0000',
  BETWEEN_100_000_AND_150_0000: 'BETWEEN_100_000_AND_150_0000',
  OVER_150_000: 'OVER_150_000',
} as const;

export interface ApplicationAttachmentsDocument {
  basicAccountApplicationAttachmentsDocument?: BasicAccountApplicationAttachmentsDocument[];
  cardApplicationAttachmentsDocument?: CardApplicationAttachmentsDocument[];
}

export interface ApplicationRef {
  uuid?: string;
}

export type ApplicationStatus = typeof ApplicationStatus[keyof typeof ApplicationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplicationStatus = {
  STARTED: 'STARTED',
  COMPLETED: 'COMPLETED',
  SIGNED: 'SIGNED',
  CANCELED: 'CANCELED',
  ATTACHMENTS_UPLOADED: 'ATTACHMENTS_UPLOADED',
} as const;

export interface ApplicationStatusDto {
  status?: ApplicationStatus;
  productRef?: string;
}

export type ApplicationStep = typeof ApplicationStep[keyof typeof ApplicationStep];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplicationStep = {
  REGISTRATION: 'REGISTRATION',
  BASIC_ACCOUNT_INFORMATION: 'BASIC_ACCOUNT_INFORMATION',
  BASIC_ACCOUNT_BENEFITS: 'BASIC_ACCOUNT_BENEFITS',
  REGULATORY_INFORMATION: 'REGULATORY_INFORMATION',
  POWER_OF_ATTORNEY: 'POWER_OF_ATTORNEY',
  COMPANY_ONLINE: 'COMPANY_ONLINE',
  CARDHOLDER: 'CARDHOLDER',
  CARDHOLDER_BENEFITS: 'CARDHOLDER_BENEFITS',
  CHOOSE_SIGNATORIES: 'CHOOSE_SIGNATORIES',
  SUMMARY: 'SUMMARY',
  SIGN: 'SIGN',
  UPLOAD_ATTACHMENTS: 'UPLOAD_ATTACHMENTS',
} as const;

export type AttachmentDocumentType = typeof AttachmentDocumentType[keyof typeof AttachmentDocumentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttachmentDocumentType = {
  COMMERCIAL_REGISTER_EXTRACT: 'COMMERCIAL_REGISTER_EXTRACT',
  FOUNDING_DOCUMENTS_OR_EQUIVALENT: 'FOUNDING_DOCUMENTS_OR_EQUIVALENT',
  ANNUAL_REPORT: 'ANNUAL_REPORT',
  PASSPORT_ID_OR_DRIVER_LICENCE: 'PASSPORT_ID_OR_DRIVER_LICENCE',
  PASSPORT_OR_ID: 'PASSPORT_OR_ID',
  SWISS_ALIENS_CARD: 'SWISS_ALIENS_CARD',
  EMPLOYMENT_CONTRACT: 'EMPLOYMENT_CONTRACT',
  AUTHENTICITY_PROOF: 'AUTHENTICITY_PROOF',
} as const;

export interface AttachmentMetaDocument {
  applicationRef?: ApplicationRef;
  attachmentDocumentType?: AttachmentDocumentType;
  attachmentContentType?: string;
  uuid?: string;
  storedAt?: string;
  customersFileName?: string;
}

export interface AttachmentUploadConfigurationDocument {
  maxFileSize?: number;
  allowedMimeTypes?: string[];
}

export interface AttorneyDto {
  gender: Gender;
  firstName: string;
  lastName: string;
  address: PostAddress;
  mobile: string;
  emailBusiness: string;
  birthdate: string;
  nationality: string;
  isSameAsAdmin: boolean;
}

export interface BankAccount {
  iban?: string;
  bankName?: string;
  bankCode?: string;
}

export interface BankAccountDocument {
  iban?: string;
  bankName?: string;
  bankCode?: string;
}

export interface BasicAccountApplicationAttachmentsDocument {
  attachmentMetaDocument?: AttachmentMetaDocument;
  attachmentDocumentType?: AttachmentDocumentType;
}

export interface BasicAccountApplicationDashboardDto {
  productRef: string;
}

export interface BasicAccountApplicationDocument {
  applicationRef?: string;
  productRef?: string;
  isFirst?: boolean;
  step?: ApplicationStep;
  status?: ApplicationStatus;
  bankAccount?: BankAccountDocument;
  limit?: number;
  createdDate?: string;
  lastModifiedDate?: string;
  documentDateTime?: string;
  scanSetId?: string;
  scanId?: string;
  applicationCreationDateTime?: string;
  pdfLanguage?: CorrespondenceLanguage;
  cancellationReason?: string;
  hasDecentralizedInvoicing?: boolean;
  decentralizedInvoicingAddress?: DecentralizedInvoicingAddress;
  productFeature?: ProductFeature[];
  isCashWithdrawalPossible?: boolean;
  companyOnlineSecurityCode?: string;
  acceptMarketingEmails?: boolean;
  expectedSpendingPerMonth?: number;
  adminIsLoyaltyProgramContact?: boolean;
  adminIsPowerOfAttorney?: boolean;
  adminIsBeneficialOwner?: boolean;
  adminIsControllingOwner?: boolean;
  adminIsSignatory?: boolean;
  hasCompanyOnCard?: boolean;
  customizedCard?: CustomizedCard;
  partnerPlusBenefit?: PartnerPlusBenefit;
  flexibleInvoicing?: FlexibleInvoicing;
  accountNumber?: string;
  company?: CompanyDocument;
  admin?: NaturalPersonDocument;
  loyaltyProgramContact?: NaturalPersonDocument;
  powerOfAttorneys?: NaturalPersonDocument[];
  noPowerOfAttorney?: boolean;
  beneficialOwner?: NaturalPersonDocument;
  controllingOwners?: NaturalPersonDocument[];
  signatories?: NaturalPersonDocument[];
  companyClassification?: CompanyClassification;
  controllerIdentification?: ControllerIdentification;
  hasOwnOffice?: boolean;
  employsOwnStaff?: boolean;
  requiredPersonAttachments?: PersonAttachment[];
  requiredCompanyAttachments?: CompanyAttachment[];
  willBeContactedBySwisscard?: boolean;
  userLanguage?: UserLanguage;
}

export interface BasicAccountApplicationDto {
  language: UserLanguage;
  selectedProduct: string;
  company: CompanyBasicDataDto;
  admin: AdminDto;
  userIsRegisteringToTheSystem?: boolean;
}

export interface BasicAccountBenefitsDto {
  basicAccountApplicationRef: string;
  productRef: string;
  partnerPlusBenefitsDto?: PartnerPlusBenefitsDto;
  isCashWithdrawalPossible: boolean;
  customizedCard?: CustomizedCard;
}

export interface BeneficialOwnerDto {
  gender: Gender;
  firstName: string;
  lastName: string;
  address: PostAddress;
  birthdate: string;
  nationality: string;
  isSameAsAdmin: boolean;
}

export interface CancelApplicationDto {
  lastApplicationFlowStep: ApplicationStep;
  cancellationReason?: string;
  productRef?: string;
}

export interface CardApplicationAttachmentsDocument {
  attachmentMetaDocument?: AttachmentMetaDocument[];
  attachmentDocumentType?: AttachmentDocumentType;
}

export interface CardApplicationDocument {
  applicationRef?: string;
  productRef?: string;
  isFirst?: boolean;
  step?: ApplicationStep;
  status?: ApplicationStatus;
  bankAccount?: BankAccountDocument;
  limit?: number;
  createdDate?: string;
  lastModifiedDate?: string;
  documentDateTime?: string;
  scanSetId?: string;
  scanId?: string;
  applicationCreationDateTime?: string;
  pdfLanguage?: CorrespondenceLanguage;
  cancellationReason?: string;
  hasDecentralizedInvoicing?: boolean;
  decentralizedInvoicingAddress?: DecentralizedInvoicingAddress;
  productFeature?: ProductFeature[];
  basicAccountApplicationRef?: string;
  adminIsCardholder?: boolean;
  cardholderIsSignatory?: boolean;
  canDigitallySign?: boolean;
  admin?: NaturalPersonDocument;
  company?: CardCompanyDocument;
  cardholder?: NaturalPersonDocument;
  signatories?: NaturalPersonDocument[];
  milesAndMore?: MilesAndMore;
  requiredAttachments?: PersonAttachment[];
  employmentInfo?: EmploymentInfo;
  decentralizedInvoicing?: DecentralizedInvoicing;
  fundsOwnershipCardholder?: NaturalPersonDocument;
  basicAccountApplicationLimit?: number;
}

export interface CardApplicationDto {
  productRef: string;
  cardholder: CardholderDto;
  employmentInfo: EmploymentInfo;
  hasDecentralizedInvoicing: boolean;
  decentralizedInvoicing?: DecentralizedInvoicing;
  fundsOwnershipCardholder?: FundsOwnershipCardholderDto;
}

export interface CardCompanyDocument {
  correspondenceLanguage?: CorrespondenceLanguage;
  address?: PostAddress;
  name?: string;
  ehraid?: string;
  limit?: number;
  legalForm?: LegalForm;
}

export interface CardholderBenefitsDto {
  customerNumber?: string;
}

export interface CardholderDto {
  gender: Gender;
  firstName: string;
  lastName: string;
  address: PostAddress;
  phoneBusiness: string;
  mobile: string;
  emailBusiness: string;
  birthdate: string;
  nationality: string;
  correspondenceLanguage: CorrespondenceLanguage;
  spendingLimit: number;
  isSameAsAdmin: boolean;
}

export interface ChangeApplicationProductDto {
  productRef: string;
  lastApplicationFlowStep: ApplicationStep;
}

export interface CompanyAttachment {
  domain?: AttachmentDocumentType;
}

export interface CompanyBasicDataDto {
  basicAccountApplicationRef?: string;
  selectedProduct?: string;
  ehraid?: string;
  uid?: string;
  chid?: string;
  name: string;
  address: PostAddress;
  phone?: string;
  legalForm: LegalForm;
  industryNogaCode?: string;
  industryBranchCode?: string;
  industrySubBranchCode?: string;
  foundationDate?: string;
  capitalNom?: number;
  enteredInTradeRegistryDate?: string;
}

export type CompanyClassification = typeof CompanyClassification[keyof typeof CompanyClassification];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyClassification = {
  LISTED_COMPANY_OR_SUBSIDIARY_MAJORITY: 'LISTED_COMPANY_OR_SUBSIDIARY_MAJORITY',
  AUTHORITY_OR_NON_PROFIT: 'AUTHORITY_OR_NON_PROFIT',
  UNREGISTERED_PARTNERSHIP: 'UNREGISTERED_PARTNERSHIP',
  BANK_OR_ANOTHER_FINANCIAL_INTERMEDIARY: 'BANK_OR_ANOTHER_FINANCIAL_INTERMEDIARY',
  NON_OPERATING_FOUNDATION: 'NON_OPERATING_FOUNDATION',
  NON_OPERATIONAL_COMPANY: 'NON_OPERATIONAL_COMPANY',
  NONE_OF_THE_AVAILABLE_CLASSIFICATIONS: 'NONE_OF_THE_AVAILABLE_CLASSIFICATIONS',
} as const;

export interface CompanyDocument {
  correspondenceLanguage?: CorrespondenceLanguage;
  address?: PostAddress;
  isCompanyManuallyEntered?: boolean;
  name?: string;
  phone?: string;
  legalForm?: LegalForm;
  industry?: CompanyIndustryDocument;
  resolvedIndustry?: string;
  foundationDate?: string;
  ehraid?: string;
  uid?: string;
  chid?: string;
  capitalNom?: number;
  enteredInTradeRegistryDate?: string;
}

export interface CompanyIndustryDocument {
  nogaCode?: string;
  branchCode?: string;
  subBranchCode?: string;
}

export interface CompanyOnlineDto {
  acceptMarketingEmails?: boolean;
  companyOnlineSecurityCode?: string;
  basicAccountApplicationRef: string;
  authorizedRepresentatives?: NaturalPersonDto[];
}

export type ControllerIdentification = typeof ControllerIdentification[keyof typeof ControllerIdentification];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ControllerIdentification = {
  SHARES: 'SHARES',
  OTHER: 'OTHER',
  DIRECTOR: 'DIRECTOR',
} as const;

export interface ControllingOwnerDto {
  gender: Gender;
  firstName: string;
  lastName: string;
  address: PostAddress;
  birthdate: string;
  nationality: string;
  isSameAsAdmin: boolean;
}

export type CorrespondenceLanguage = typeof CorrespondenceLanguage[keyof typeof CorrespondenceLanguage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CorrespondenceLanguage = {
  GERMAN: 'GERMAN',
  FRENCH: 'FRENCH',
  ENGLISH: 'ENGLISH',
  ITALIAN: 'ITALIAN',
} as const;

export interface Country {
  alpha2?: string;
}

export interface CountryDto {
  name?: string;
  isoCode?: string;
  telephoneCode?: string;
}

export interface CustomizationLinkDocument {
  link?: string;
}

export type CustomizedCard = typeof CustomizedCard[keyof typeof CustomizedCard];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomizedCard = {
  NONE: 'NONE',
  LOGO_ON_CARD: 'LOGO_ON_CARD',
  PICTURE_OR_LOGO_ON_CARD: 'PICTURE_OR_LOGO_ON_CARD',
} as const;

export interface DashboardBasicAccountApplicationDocument {
  applicationRef?: string;
  productRef?: string;
  isFirst?: boolean;
  step?: ApplicationStep;
  status?: ApplicationStatus;
  bankAccount?: BankAccountDocument;
  limit?: number;
  createdDate?: string;
  lastModifiedDate?: string;
  documentDateTime?: string;
  scanSetId?: string;
  scanId?: string;
  applicationCreationDateTime?: string;
  pdfLanguage?: CorrespondenceLanguage;
  cancellationReason?: string;
  hasDecentralizedInvoicing?: boolean;
  decentralizedInvoicingAddress?: DecentralizedInvoicingAddress;
  productFeature?: ProductFeature[];
  companyName?: string;
  isSoleProprietorship?: boolean;
  customizedCard?: CustomizedCard;
}

export interface DashboardCardApplicationDocument {
  applicationRef?: string;
  productRef?: string;
  isFirst?: boolean;
  step?: ApplicationStep;
  status?: ApplicationStatus;
  bankAccount?: BankAccountDocument;
  limit?: number;
  createdDate?: string;
  lastModifiedDate?: string;
  documentDateTime?: string;
  scanSetId?: string;
  scanId?: string;
  applicationCreationDateTime?: string;
  pdfLanguage?: CorrespondenceLanguage;
  cancellationReason?: string;
  hasDecentralizedInvoicing?: boolean;
  decentralizedInvoicingAddress?: DecentralizedInvoicingAddress;
  productFeature?: ProductFeature[];
  basicAccountApplicationRef?: string;
  cardholderFirstName?: string;
  cardholderLastName?: string;
}

export interface DashboardDocument {
  cardApplications?: DashboardCardApplicationDocument[];
  basicAccountApplications?: DashboardBasicAccountApplicationDocument[];
}

export interface DecentralizedInvoicing {
  fundsOwnership?: FundsOwnership;
  bankAccount?: BankAccount;
}

export type DecentralizedInvoicingAddress = typeof DecentralizedInvoicingAddress[keyof typeof DecentralizedInvoicingAddress];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DecentralizedInvoicingAddress = {
  COMPANY_ADDRESS: 'COMPANY_ADDRESS',
  PRIVATE_ADDRESS: 'PRIVATE_ADDRESS',
} as const;

export interface EmploymentInfo {
  companyPosition?: string;
  isCurrentlyEmployed: boolean;
  isInPermanentEmployment: boolean;
  isCrossBorderWorker?: boolean;
  residencePermit?: ResidencePermit;
  annualGrossIncome?: AnnualGrossIncome;
}

export interface FlexibleInvoicing {
  address?: PostAddress;
}

export type FundsOwnership = typeof FundsOwnership[keyof typeof FundsOwnership];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FundsOwnership = {
  ADMIN: 'ADMIN',
  COMPANY: 'COMPANY',
  ADMIN_AND_COMPANY: 'ADMIN_AND_COMPANY',
  OTHER: 'OTHER',
} as const;

export interface FundsOwnershipCardholderDto {
  gender: Gender;
  firstName: string;
  lastName: string;
  address: PostAddress;
  birthdate: string;
  nationality: string;
}

export type Gender = typeof Gender[keyof typeof Gender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
} as const;

export interface GeneralCompanyInformationDto {
  basicAccountApplicationRef: string;
  limit: number;
  expectedSpendingPerMonth: number;
  correspondenceLanguage: CorrespondenceLanguage;
  bankCode?: string;
  bankName: string;
  iban: string;
  flexibleInvoicing?: FlexibleInvoicing;
  hasDecentralizedInvoicing?: boolean;
  decentralizedInvoicingAddress?: DecentralizedInvoicingAddress;
  hasCompanyOnCard: boolean;
}

export interface IndustryDto {
  code?: string;
  name?: string;
  subIndustryBranch?: IndustryDto[];
}

export type LegalForm = typeof LegalForm[keyof typeof LegalForm];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LegalForm = {
  SOLE_PROPRIETORSHIP: 'SOLE_PROPRIETORSHIP',
  COLLECTIVE_PROPRIETORSHIP: 'COLLECTIVE_PROPRIETORSHIP',
  LIMITED_COMPANY: 'LIMITED_COMPANY',
  LIMITED_LIABILITY_COMPANY: 'LIMITED_LIABILITY_COMPANY',
  COLLECTIVE: 'COLLECTIVE',
  ASSOCIATION: 'ASSOCIATION',
  FOUNDATION: 'FOUNDATION',
  SPECIAL_LEGAL_FORM: 'SPECIAL_LEGAL_FORM',
  SWISS_BRANCH: 'SWISS_BRANCH',
  LIMITED_PARTNERSHIP: 'LIMITED_PARTNERSHIP',
  ASSOCIATION_LIMITED_BY_SHARES: 'ASSOCIATION_LIMITED_BY_SHARES',
  INDIVISION: 'INDIVISION',
  PUBLIC_LAW_INSTITUTION: 'PUBLIC_LAW_INSTITUTION',
  NON_COMMERCIAL_POWER_OF_ATTORNEY: 'NON_COMMERCIAL_POWER_OF_ATTORNEY',
  FOREIGN_BRANCH: 'FOREIGN_BRANCH',
} as const;

export interface MilesAndMore {
  isMember?: boolean;
  customerNumber?: string;
}

export interface NaturalPersonDocument {
  correspondenceLanguage?: CorrespondenceLanguage;
  address?: PostAddress;
  gender?: Gender;
  firstName?: string;
  lastName?: string;
  birthdate?: string;
  emailPrivate?: string;
  emailBusiness?: string;
  mobile?: string;
  phonePrivate?: string;
  phoneBusiness?: string;
  nationality?: Country;
  isCompanyOnlineAdmin?: boolean;
  isStatementRecipient?: boolean;
  isCardsOrPinRecipient?: boolean;
}

export interface NaturalPersonDto {
  email?: string;
  isCompanyOnlineAdmin?: boolean;
  isStatementRecipient?: boolean;
  isCardsOrPinRecipient?: boolean;
}

export interface NogaCodeDto {
  section?: string;
  code?: string;
  text?: string;
}

export interface PartnerPlusBenefit {
  username?: string;
  receiveInfoMail?: boolean;
  subscribeToNewsletter?: boolean;
  companyDepartment?: string;
  companyPosition?: string;
  travelersCount?: TravelersCount;
  annualFlightSpending?: AnnualFlightSpending;
}

export interface PartnerPlusBenefitContactDto {
  gender: Gender;
  firstName: string;
  lastName: string;
  companyDepartment?: string;
  companyPosition?: string;
  mobile: string;
  emailBusiness: string;
  correspondenceLanguage: CorrespondenceLanguage;
  isSameAsAdmin: boolean;
}

export interface PartnerPlusBenefitGeneralDto {
  receiveInfoMail?: boolean;
  subscribeToNewsletter?: boolean;
  companyDepartment?: string;
  companyPosition?: string;
  expectedAnnualFlightSpending?: AnnualFlightSpending;
  companyTravelersCount?: TravelersCount;
}

export interface PartnerPlusBenefitsDto {
  username?: string;
  contact?: PartnerPlusBenefitContactDto;
  general?: PartnerPlusBenefitGeneralDto;
}

export interface PersonAttachment {
  domain?: AttachmentDocumentType;
  firstName?: string;
  lastName?: string;
}

export interface PostAddress {
  street?: string;
  streetNr?: string;
  zipCode?: string;
  city?: string;
  country: Country;
}

export interface PowerOfAttorneyDto {
  basicAccountApplicationRef: string;
  attorneys: AttorneyDto[];
}

export interface Product {
  features?: ProductFeature[];
  family?: ProductFamily;
  productRef?: ProductRef;
  isDefaultForFamily?: boolean;
  currency?: ProductCurrency;
  bySalesLink?: boolean;
  isActive?: boolean;
}

export type ProductCurrency = typeof ProductCurrency[keyof typeof ProductCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductCurrency = {
  CHF: 'CHF',
  EUR: 'EUR',
  USD: 'USD',
} as const;

export type ProductFamily = typeof ProductFamily[keyof typeof ProductFamily];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductFamily = {
  SWISS_SME: 'SWISS_SME',
  CS_DUO: 'CS_DUO',
  CS_SINGLE: 'CS_SINGLE',
  SC_SINGLE: 'SC_SINGLE',
} as const;

export type ProductFeature = typeof ProductFeature[keyof typeof ProductFeature];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductFeature = {
  PARTNER_PLUS_BENEFIT: 'PARTNER_PLUS_BENEFIT',
  MILES_AND_MORE: 'MILES_AND_MORE',
  MEMBERSHIP_REWARDS: 'MEMBERSHIP_REWARDS',
  INSURANCE_PLUS_INCLUDED: 'INSURANCE_PLUS_INCLUDED',
  INSURANCE_PLUS_OPTIONAL: 'INSURANCE_PLUS_OPTIONAL',
  INSURANCE_PLUS_OPTIONAL_SWISSCARD: 'INSURANCE_PLUS_OPTIONAL_SWISSCARD',
  INSURANCE_PLUS_INCLUDED_SWISSCARD: 'INSURANCE_PLUS_INCLUDED_SWISSCARD',
  FLEXIBLE_INVOICING: 'FLEXIBLE_INVOICING',
  TURNOVER_BONUS_LOW: 'TURNOVER_BONUS_LOW',
  TURNOVER_BONUS_HIGH: 'TURNOVER_BONUS_HIGH',
  PICTURE_OR_LOGO_ON_CARD: 'PICTURE_OR_LOGO_ON_CARD',
  DECENTRALIZED_INVOICING: 'DECENTRALIZED_INVOICING',
} as const;

export interface ProductRef {
  value?: string;
}

export interface ProductsDto {
  productList?: Product[];
  allProducts?: Product[];
}

export interface RegulatoryInfoDto {
  basicAccountApplicationRef: string;
  companyClassification?: CompanyClassification;
  controllerIdentification?: ControllerIdentification;
  hasOwnOffice?: boolean;
  employsOwnStaff?: boolean;
  beneficialOwner?: BeneficialOwnerDto;
  controllingOwners?: ControllingOwnerDto[];
}

export type ResidencePermit = typeof ResidencePermit[keyof typeof ResidencePermit];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResidencePermit = {
  B: 'B',
  C: 'C',
  OTHER: 'OTHER',
} as const;

export interface SignatoriesDto {
  signatories: SignatoryDto[];
}

export interface SignatoryDto {
  gender: Gender;
  firstName: string;
  lastName: string;
  address: PostAddress;
  birthdate: string;
  nationality: string;
  isSameAsCardholder: boolean;
}

export interface SigningProcessDocument {
  signingProcessRef?: string;
  isIdentificationRejected?: boolean;
  identificationRejectionReason?: SigningProcessIdentificationRejectionReason;
  isSigningRejected?: boolean;
}

export type SigningProcessIdentificationRejectionReason = typeof SigningProcessIdentificationRejectionReason[keyof typeof SigningProcessIdentificationRejectionReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SigningProcessIdentificationRejectionReason = {
  NO_DATA_MATCH: 'NO_DATA_MATCH',
  NEGATIVE_PROFILING: 'NEGATIVE_PROFILING',
  FALSE_BIRTHDATE: 'FALSE_BIRTHDATE',
  MANIPULATIVE_TRY: 'MANIPULATIVE_TRY',
  FALSE_PERS_ATTRIBUTES: 'FALSE_PERS_ATTRIBUTES',
  FRAUD_DOCUMENT: 'FRAUD_DOCUMENT',
  MACHINE_READABLE_ZONE_CHECK_DIGIT_ERROR: 'MACHINE_READABLE_ZONE_CHECK_DIGIT_ERROR',
  DIFFERING_AGE: 'DIFFERING_AGE',
  AGAIN: 'AGAIN',
  NO_DATA_MATCH_AND_MANIPULATIVE_TRY: 'NO_DATA_MATCH_AND_MANIPULATIVE_TRY',
  NO_DATA_MATCH_AND_FALSE_PERS_ATTRIBUTES: 'NO_DATA_MATCH_AND_FALSE_PERS_ATTRIBUTES',
  NO_DATA_MATCH_AND_NEGATIVE_PROFILING: 'NO_DATA_MATCH_AND_NEGATIVE_PROFILING',
  NO_DATA_MATCH_AND_FALSE_BIRTHDATE: 'NO_DATA_MATCH_AND_FALSE_BIRTHDATE',
  NATIONALITY_NOT_SUPPORTED: 'NATIONALITY_NOT_SUPPORTED',
} as const;

export type TravelersCount = typeof TravelersCount[keyof typeof TravelersCount];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TravelersCount = {
  ONE: 'ONE',
  BETWEEN_2_AND_5: 'BETWEEN_2_AND_5',
  BETWEEN_6_AND_10: 'BETWEEN_6_AND_10',
  OVER_10: 'OVER_10',
} as const;

export interface UnfinishedApplicationsDocument {
  basicAccountApplication?: BasicAccountApplicationDocument;
  cardApplication?: CardApplicationDocument;
  signingProcess?: SigningProcessDocument;
  noValidApplications?: boolean;
}

export type UserLanguage = typeof UserLanguage[keyof typeof UserLanguage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserLanguage = {
  ENGLISH: 'ENGLISH',
  ITALIAN: 'ITALIAN',
  FRENCH: 'FRENCH',
  GERMAN: 'GERMAN',
} as const;

export type ApplicationApiGetApplicationPdfFileName200 = {[key: string]: string};

export type BasicAccountApplicationApiFetchParams = {
applicationRef: string;
};

export type CardApplicationApiStartCardApplicationParams = {
type: string;
};

export type CardApplicationApiUpdateCardholderParams = {
type: string;
};

export type CardApplicationApiUpdateCardSignatoriesParams = {
type: string;
};

export type CardApplicationApiPrepareCardApplicationForSigningParams = {
type: string;
};

export type CountryApiIndexParams = {
locale?: string;
};

export type FeatureToggleApiIndex200 = {[key: string]: boolean};

export type IndustryApiIndexParams = {
locale?: string;
};

export type NogaApiIndexParams = {
locale?: string;
};

export type PowerOfAttorneyApiIndexParams = {
pdfLanguage: CorrespondenceLanguage;
};

export type SigningProcessApiSignFirstCardApplicationParams = {
language?: string;
};

/**
 * @summary Retrieves unfinished applications with the provided status
 */
export type applicationApiGetApplicationsResponse200 = {
  data: UnfinishedApplicationsDocument
  status: 200
}
    
export type applicationApiGetApplicationsResponseSuccess = (applicationApiGetApplicationsResponse200) & {
  headers: Headers;
};
;

export type applicationApiGetApplicationsResponse = (applicationApiGetApplicationsResponseSuccess)

export const getApplicationApiGetApplicationsUrl = () => {


  

  return `/api/protected/applications`
}

export const applicationApiGetApplications = async ( options?: RequestInit): Promise<applicationApiGetApplicationsResponse> => {
  
  const res = await fetch(getApplicationApiGetApplicationsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: applicationApiGetApplicationsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as applicationApiGetApplicationsResponse
}



/**
 * @summary Fetches the Application PDF Filename for the Application with applicationRef.
 */
export type applicationApiGetApplicationPdfFileNameResponse200 = {
  data: ApplicationApiGetApplicationPdfFileName200
  status: 200
}
    
export type applicationApiGetApplicationPdfFileNameResponseSuccess = (applicationApiGetApplicationPdfFileNameResponse200) & {
  headers: Headers;
};
;

export type applicationApiGetApplicationPdfFileNameResponse = (applicationApiGetApplicationPdfFileNameResponseSuccess)

export const getApplicationApiGetApplicationPdfFileNameUrl = (applicationRef: string,) => {


  

  return `/api/protected/applications/${applicationRef}`
}

export const applicationApiGetApplicationPdfFileName = async (applicationRef: string, options?: RequestInit): Promise<applicationApiGetApplicationPdfFileNameResponse> => {
  
  const res = await fetch(getApplicationApiGetApplicationPdfFileNameUrl(applicationRef),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: applicationApiGetApplicationPdfFileNameResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as applicationApiGetApplicationPdfFileNameResponse
}



/**
 * @summary Handle manual submission of documents from the user.
 */
export type applicationApiManuallySignApplicationResponse200 = {
  data: void
  status: 200
}
    
export type applicationApiManuallySignApplicationResponseSuccess = (applicationApiManuallySignApplicationResponse200) & {
  headers: Headers;
};
;

export type applicationApiManuallySignApplicationResponse = (applicationApiManuallySignApplicationResponseSuccess)

export const getApplicationApiManuallySignApplicationUrl = (applicationRef: string,) => {


  

  return `/api/protected/applications/${applicationRef}/manually-sign-application`
}

export const applicationApiManuallySignApplication = async (applicationRef: string, options?: RequestInit): Promise<applicationApiManuallySignApplicationResponse> => {
  
  const res = await fetch(getApplicationApiManuallySignApplicationUrl(applicationRef),
  {      
    ...options,
    method: 'POST'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: applicationApiManuallySignApplicationResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as applicationApiManuallySignApplicationResponse
}



/**
 * @summary Updates the application status
 */
export type applicationApiUpdateApplicationStatusResponse200 = {
  data: void
  status: 200
}
    
export type applicationApiUpdateApplicationStatusResponseSuccess = (applicationApiUpdateApplicationStatusResponse200) & {
  headers: Headers;
};
;

export type applicationApiUpdateApplicationStatusResponse = (applicationApiUpdateApplicationStatusResponseSuccess)

export const getApplicationApiUpdateApplicationStatusUrl = (applicationRef: string,) => {


  

  return `/api/protected/applications/${applicationRef}/status`
}

export const applicationApiUpdateApplicationStatus = async (applicationRef: string,
    applicationStatusDto: ApplicationStatusDto, options?: RequestInit): Promise<applicationApiUpdateApplicationStatusResponse> => {
  
  const res = await fetch(getApplicationApiUpdateApplicationStatusUrl(applicationRef),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      applicationStatusDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: applicationApiUpdateApplicationStatusResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as applicationApiUpdateApplicationStatusResponse
}



/**
 * @summary Fetches the Application PDF for the Application with applicationRef.
 */
export type applicationApiGetApplicationPdfResponse200 = {
  data: Blob
  status: 200
}
    
export type applicationApiGetApplicationPdfResponseSuccess = (applicationApiGetApplicationPdfResponse200) & {
  headers: Headers;
};
;

export type applicationApiGetApplicationPdfResponse = (applicationApiGetApplicationPdfResponseSuccess)

export const getApplicationApiGetApplicationPdfUrl = (applicationRef: string,
    pdfFileName: string,) => {


  

  return `/api/protected/applications/${applicationRef}/${pdfFileName}`
}

export const applicationApiGetApplicationPdf = async (applicationRef: string,
    pdfFileName: string, options?: RequestInit): Promise<applicationApiGetApplicationPdfResponse> => {
  
  const res = await fetch(getApplicationApiGetApplicationPdfUrl(applicationRef,pdfFileName),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: applicationApiGetApplicationPdfResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as applicationApiGetApplicationPdfResponse
}



/**
 * @summary Fetch all attachments for applications.
 */
export type attachmentApiDownloadApplicationAttachmentsDocumentResponse200 = {
  data: ApplicationAttachmentsDocument
  status: 200
}
    
export type attachmentApiDownloadApplicationAttachmentsDocumentResponseSuccess = (attachmentApiDownloadApplicationAttachmentsDocumentResponse200) & {
  headers: Headers;
};
;

export type attachmentApiDownloadApplicationAttachmentsDocumentResponse = (attachmentApiDownloadApplicationAttachmentsDocumentResponseSuccess)

export const getAttachmentApiDownloadApplicationAttachmentsDocumentUrl = () => {


  

  return `/api/protected/application/attachment`
}

export const attachmentApiDownloadApplicationAttachmentsDocument = async ( options?: RequestInit): Promise<attachmentApiDownloadApplicationAttachmentsDocumentResponse> => {
  
  const res = await fetch(getAttachmentApiDownloadApplicationAttachmentsDocumentUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: attachmentApiDownloadApplicationAttachmentsDocumentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as attachmentApiDownloadApplicationAttachmentsDocumentResponse
}



/**
 * @summary Uploads the document and stores it.
 */
export type attachmentApiUploadDocumentResponse200 = {
  data: AttachmentMetaDocument
  status: 200
}
    
export type attachmentApiUploadDocumentResponseSuccess = (attachmentApiUploadDocumentResponse200) & {
  headers: Headers;
};
;

export type attachmentApiUploadDocumentResponse = (attachmentApiUploadDocumentResponseSuccess)

export const getAttachmentApiUploadDocumentUrl = (applicationRef: string,
    documentType: string,) => {


  

  return `/api/protected/application/${applicationRef}/attachment/${documentType}`
}

export const attachmentApiUploadDocument = async (applicationRef: string,
    documentType: string, options?: RequestInit): Promise<attachmentApiUploadDocumentResponse> => {
  
  const res = await fetch(getAttachmentApiUploadDocumentUrl(applicationRef,documentType),
  {      
    ...options,
    method: 'POST'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: attachmentApiUploadDocumentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as attachmentApiUploadDocumentResponse
}



export type attachmentApiDeleteDocumentResponse200 = {
  data: void
  status: 200
}
    
export type attachmentApiDeleteDocumentResponseSuccess = (attachmentApiDeleteDocumentResponse200) & {
  headers: Headers;
};
;

export type attachmentApiDeleteDocumentResponse = (attachmentApiDeleteDocumentResponseSuccess)

export const getAttachmentApiDeleteDocumentUrl = (applicationRef: string,
    uuid: string,) => {


  

  return `/api/protected/application/${applicationRef}/attachment/${uuid}`
}

export const attachmentApiDeleteDocument = async (applicationRef: string,
    uuid: string, options?: RequestInit): Promise<attachmentApiDeleteDocumentResponse> => {
  
  const res = await fetch(getAttachmentApiDeleteDocumentUrl(applicationRef,uuid),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: attachmentApiDeleteDocumentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as attachmentApiDeleteDocumentResponse
}



/**
 * @summary Download a document for a given attachment.
 */
export type attachmentApiDownloadDocumentResponse200 = {
  data: Blob
  status: 200
}
    
export type attachmentApiDownloadDocumentResponseSuccess = (attachmentApiDownloadDocumentResponse200) & {
  headers: Headers;
};
;

export type attachmentApiDownloadDocumentResponse = (attachmentApiDownloadDocumentResponseSuccess)

export const getAttachmentApiDownloadDocumentUrl = (applicationRef: string,
    uuid: string,) => {


  

  return `/api/protected/application/${applicationRef}/attachment/${uuid}/`
}

export const attachmentApiDownloadDocument = async (applicationRef: string,
    uuid: string, options?: RequestInit): Promise<attachmentApiDownloadDocumentResponse> => {
  
  const res = await fetch(getAttachmentApiDownloadDocumentUrl(applicationRef,uuid),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: attachmentApiDownloadDocumentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as attachmentApiDownloadDocumentResponse
}



/**
 * @summary Gets the attachment upload configurations.
 */
export type attachmentApiGetPropertiesResponse200 = {
  data: AttachmentUploadConfigurationDocument
  status: 200
}
    
export type attachmentApiGetPropertiesResponseSuccess = (attachmentApiGetPropertiesResponse200) & {
  headers: Headers;
};
;

export type attachmentApiGetPropertiesResponse = (attachmentApiGetPropertiesResponseSuccess)

export const getAttachmentApiGetPropertiesUrl = () => {


  

  return `/api/protected/attachment/properties`
}

export const attachmentApiGetProperties = async ( options?: RequestInit): Promise<attachmentApiGetPropertiesResponse> => {
  
  const res = await fetch(getAttachmentApiGetPropertiesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: attachmentApiGetPropertiesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as attachmentApiGetPropertiesResponse
}



/**
 * @summary Fetches a basic account application by reference
 */
export type basicAccountApplicationApiFetchResponse200 = {
  data: BasicAccountApplicationDocument
  status: 200
}
    
export type basicAccountApplicationApiFetchResponseSuccess = (basicAccountApplicationApiFetchResponse200) & {
  headers: Headers;
};
;

export type basicAccountApplicationApiFetchResponse = (basicAccountApplicationApiFetchResponseSuccess)

export const getBasicAccountApplicationApiFetchUrl = (params: BasicAccountApplicationApiFetchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/protected/application/basic-account?${stringifiedParams}` : `/api/protected/application/basic-account`
}

export const basicAccountApplicationApiFetch = async (params: BasicAccountApplicationApiFetchParams, options?: RequestInit): Promise<basicAccountApplicationApiFetchResponse> => {
  
  const res = await fetch(getBasicAccountApplicationApiFetchUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: basicAccountApplicationApiFetchResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as basicAccountApplicationApiFetchResponse
}



/**
 * @summary Create a basic account application.
 */
export type basicAccountApplicationApiCreateBasicAccountApplicationResponse200 = {
  data: string
  status: 200
}
    
export type basicAccountApplicationApiCreateBasicAccountApplicationResponseSuccess = (basicAccountApplicationApiCreateBasicAccountApplicationResponse200) & {
  headers: Headers;
};
;

export type basicAccountApplicationApiCreateBasicAccountApplicationResponse = (basicAccountApplicationApiCreateBasicAccountApplicationResponseSuccess)

export const getBasicAccountApplicationApiCreateBasicAccountApplicationUrl = () => {


  

  return `/api/protected/application/basic-account`
}

export const basicAccountApplicationApiCreateBasicAccountApplication = async (basicAccountApplicationDto: BasicAccountApplicationDto, options?: RequestInit): Promise<basicAccountApplicationApiCreateBasicAccountApplicationResponse> => {
  
  const res = await fetch(getBasicAccountApplicationApiCreateBasicAccountApplicationUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      basicAccountApplicationDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: basicAccountApplicationApiCreateBasicAccountApplicationResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as basicAccountApplicationApiCreateBasicAccountApplicationResponse
}



/**
 * @summary Requests additional benefits for the basic account.
 */
export type basicAccountApplicationApiUpdateBasicAccountBenefitsResponse200 = {
  data: void
  status: 200
}
    
export type basicAccountApplicationApiUpdateBasicAccountBenefitsResponseSuccess = (basicAccountApplicationApiUpdateBasicAccountBenefitsResponse200) & {
  headers: Headers;
};
;

export type basicAccountApplicationApiUpdateBasicAccountBenefitsResponse = (basicAccountApplicationApiUpdateBasicAccountBenefitsResponseSuccess)

export const getBasicAccountApplicationApiUpdateBasicAccountBenefitsUrl = () => {


  

  return `/api/protected/application/basic-account/benefits`
}

export const basicAccountApplicationApiUpdateBasicAccountBenefits = async (basicAccountBenefitsDto: BasicAccountBenefitsDto, options?: RequestInit): Promise<basicAccountApplicationApiUpdateBasicAccountBenefitsResponse> => {
  
  const res = await fetch(getBasicAccountApplicationApiUpdateBasicAccountBenefitsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      basicAccountBenefitsDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: basicAccountApplicationApiUpdateBasicAccountBenefitsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as basicAccountApplicationApiUpdateBasicAccountBenefitsResponse
}



/**
 * @summary Updates company basic data.
 */
export type basicAccountApplicationApiUpdateCompanyBasicDataResponse200 = {
  data: void
  status: 200
}
    
export type basicAccountApplicationApiUpdateCompanyBasicDataResponseSuccess = (basicAccountApplicationApiUpdateCompanyBasicDataResponse200) & {
  headers: Headers;
};
;

export type basicAccountApplicationApiUpdateCompanyBasicDataResponse = (basicAccountApplicationApiUpdateCompanyBasicDataResponseSuccess)

export const getBasicAccountApplicationApiUpdateCompanyBasicDataUrl = () => {


  

  return `/api/protected/application/basic-account/company`
}

export const basicAccountApplicationApiUpdateCompanyBasicData = async (companyBasicDataDto: CompanyBasicDataDto, options?: RequestInit): Promise<basicAccountApplicationApiUpdateCompanyBasicDataResponse> => {
  
  const res = await fetch(getBasicAccountApplicationApiUpdateCompanyBasicDataUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      companyBasicDataDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: basicAccountApplicationApiUpdateCompanyBasicDataResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as basicAccountApplicationApiUpdateCompanyBasicDataResponse
}



/**
 * @summary Fills the company Online section for authorized representatives.
 */
export type basicAccountApplicationApiUpdateCompanyOnlineResponse200 = {
  data: void
  status: 200
}
    
export type basicAccountApplicationApiUpdateCompanyOnlineResponseSuccess = (basicAccountApplicationApiUpdateCompanyOnlineResponse200) & {
  headers: Headers;
};
;

export type basicAccountApplicationApiUpdateCompanyOnlineResponse = (basicAccountApplicationApiUpdateCompanyOnlineResponseSuccess)

export const getBasicAccountApplicationApiUpdateCompanyOnlineUrl = () => {


  

  return `/api/protected/application/basic-account/company-online`
}

export const basicAccountApplicationApiUpdateCompanyOnline = async (companyOnlineDto: CompanyOnlineDto, options?: RequestInit): Promise<basicAccountApplicationApiUpdateCompanyOnlineResponse> => {
  
  const res = await fetch(getBasicAccountApplicationApiUpdateCompanyOnlineUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      companyOnlineDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: basicAccountApplicationApiUpdateCompanyOnlineResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as basicAccountApplicationApiUpdateCompanyOnlineResponse
}



/**
 * @summary Adds the general company information.
 */
export type basicAccountApplicationApiUpdateGeneralCompanyInformationResponse200 = {
  data: void
  status: 200
}
    
export type basicAccountApplicationApiUpdateGeneralCompanyInformationResponseSuccess = (basicAccountApplicationApiUpdateGeneralCompanyInformationResponse200) & {
  headers: Headers;
};
;

export type basicAccountApplicationApiUpdateGeneralCompanyInformationResponse = (basicAccountApplicationApiUpdateGeneralCompanyInformationResponseSuccess)

export const getBasicAccountApplicationApiUpdateGeneralCompanyInformationUrl = () => {


  

  return `/api/protected/application/basic-account/gci`
}

export const basicAccountApplicationApiUpdateGeneralCompanyInformation = async (generalCompanyInformationDto: GeneralCompanyInformationDto, options?: RequestInit): Promise<basicAccountApplicationApiUpdateGeneralCompanyInformationResponse> => {
  
  const res = await fetch(getBasicAccountApplicationApiUpdateGeneralCompanyInformationUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      generalCompanyInformationDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: basicAccountApplicationApiUpdateGeneralCompanyInformationResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as basicAccountApplicationApiUpdateGeneralCompanyInformationResponse
}



/**
 * @summary Assigns power of attorneys to basic account application.
 */
export type basicAccountApplicationApiAssignPowerOfAttorneysResponse200 = {
  data: void
  status: 200
}
    
export type basicAccountApplicationApiAssignPowerOfAttorneysResponseSuccess = (basicAccountApplicationApiAssignPowerOfAttorneysResponse200) & {
  headers: Headers;
};
;

export type basicAccountApplicationApiAssignPowerOfAttorneysResponse = (basicAccountApplicationApiAssignPowerOfAttorneysResponseSuccess)

export const getBasicAccountApplicationApiAssignPowerOfAttorneysUrl = () => {


  

  return `/api/protected/application/basic-account/power-of-attorney`
}

export const basicAccountApplicationApiAssignPowerOfAttorneys = async (powerOfAttorneyDto: PowerOfAttorneyDto, options?: RequestInit): Promise<basicAccountApplicationApiAssignPowerOfAttorneysResponse> => {
  
  const res = await fetch(getBasicAccountApplicationApiAssignPowerOfAttorneysUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      powerOfAttorneyDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: basicAccountApplicationApiAssignPowerOfAttorneysResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as basicAccountApplicationApiAssignPowerOfAttorneysResponse
}



/**
 * @summary Adds regulatory info, more precisely the controlling and/or beneficial owners of the company.
 */
export type basicAccountApplicationApiUpdateRegulatoryInfoResponse200 = {
  data: void
  status: 200
}
    
export type basicAccountApplicationApiUpdateRegulatoryInfoResponseSuccess = (basicAccountApplicationApiUpdateRegulatoryInfoResponse200) & {
  headers: Headers;
};
;

export type basicAccountApplicationApiUpdateRegulatoryInfoResponse = (basicAccountApplicationApiUpdateRegulatoryInfoResponseSuccess)

export const getBasicAccountApplicationApiUpdateRegulatoryInfoUrl = () => {


  

  return `/api/protected/application/basic-account/regulatory-info`
}

export const basicAccountApplicationApiUpdateRegulatoryInfo = async (regulatoryInfoDto: RegulatoryInfoDto, options?: RequestInit): Promise<basicAccountApplicationApiUpdateRegulatoryInfoResponse> => {
  
  const res = await fetch(getBasicAccountApplicationApiUpdateRegulatoryInfoUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      regulatoryInfoDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: basicAccountApplicationApiUpdateRegulatoryInfoResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as basicAccountApplicationApiUpdateRegulatoryInfoResponse
}



/**
 * @summary Cancels the Basic account application with applicationRef
 */
export type basicAccountApplicationApiCancelBasicAccountApplicationResponse200 = {
  data: void
  status: 200
}
    
export type basicAccountApplicationApiCancelBasicAccountApplicationResponseSuccess = (basicAccountApplicationApiCancelBasicAccountApplicationResponse200) & {
  headers: Headers;
};
;

export type basicAccountApplicationApiCancelBasicAccountApplicationResponse = (basicAccountApplicationApiCancelBasicAccountApplicationResponseSuccess)

export const getBasicAccountApplicationApiCancelBasicAccountApplicationUrl = (baaRef: string,) => {


  

  return `/api/protected/application/basic-account/${baaRef}/cancel`
}

export const basicAccountApplicationApiCancelBasicAccountApplication = async (baaRef: string,
    cancelApplicationDto: CancelApplicationDto, options?: RequestInit): Promise<basicAccountApplicationApiCancelBasicAccountApplicationResponse> => {
  
  const res = await fetch(getBasicAccountApplicationApiCancelBasicAccountApplicationUrl(baaRef),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      cancelApplicationDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: basicAccountApplicationApiCancelBasicAccountApplicationResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as basicAccountApplicationApiCancelBasicAccountApplicationResponse
}



/**
 * @summary Changes the product of the Basic account application with applicationRef
 */
export type basicAccountApplicationApiChangeProductResponse200 = {
  data: void
  status: 200
}
    
export type basicAccountApplicationApiChangeProductResponseSuccess = (basicAccountApplicationApiChangeProductResponse200) & {
  headers: Headers;
};
;

export type basicAccountApplicationApiChangeProductResponse = (basicAccountApplicationApiChangeProductResponseSuccess)

export const getBasicAccountApplicationApiChangeProductUrl = (baaRef: string,) => {


  

  return `/api/protected/application/basic-account/${baaRef}/change-product`
}

export const basicAccountApplicationApiChangeProduct = async (baaRef: string,
    changeApplicationProductDto: ChangeApplicationProductDto, options?: RequestInit): Promise<basicAccountApplicationApiChangeProductResponse> => {
  
  const res = await fetch(getBasicAccountApplicationApiChangeProductUrl(baaRef),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      changeApplicationProductDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: basicAccountApplicationApiChangeProductResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as basicAccountApplicationApiChangeProductResponse
}



/**
 * @summary Generates the customization card link.
 */
export type basicAccountApplicationApiGetPictureOrLogoImageServiceLinkResponse200 = {
  data: CustomizationLinkDocument
  status: 200
}
    
export type basicAccountApplicationApiGetPictureOrLogoImageServiceLinkResponseSuccess = (basicAccountApplicationApiGetPictureOrLogoImageServiceLinkResponse200) & {
  headers: Headers;
};
;

export type basicAccountApplicationApiGetPictureOrLogoImageServiceLinkResponse = (basicAccountApplicationApiGetPictureOrLogoImageServiceLinkResponseSuccess)

export const getBasicAccountApplicationApiGetPictureOrLogoImageServiceLinkUrl = (baaRef: string,
    language: CorrespondenceLanguage,) => {


  

  return `/api/protected/application/basic-account/${baaRef}/image-service-link/${language}`
}

export const basicAccountApplicationApiGetPictureOrLogoImageServiceLink = async (baaRef: string,
    language: CorrespondenceLanguage, options?: RequestInit): Promise<basicAccountApplicationApiGetPictureOrLogoImageServiceLinkResponse> => {
  
  const res = await fetch(getBasicAccountApplicationApiGetPictureOrLogoImageServiceLinkUrl(baaRef,language),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: basicAccountApplicationApiGetPictureOrLogoImageServiceLinkResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as basicAccountApplicationApiGetPictureOrLogoImageServiceLinkResponse
}



/**
 * @summary Starts a card application.
 */
export type cardApplicationApiStartCardApplicationResponse200 = {
  data: string
  status: 200
}
    
export type cardApplicationApiStartCardApplicationResponseSuccess = (cardApplicationApiStartCardApplicationResponse200) & {
  headers: Headers;
};
;

export type cardApplicationApiStartCardApplicationResponse = (cardApplicationApiStartCardApplicationResponseSuccess)

export const getCardApplicationApiStartCardApplicationUrl = (baaRef: string,
    params: CardApplicationApiStartCardApplicationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/protected/basicAccountApplications/${baaRef}/cardApplications?${stringifiedParams}` : `/api/protected/basicAccountApplications/${baaRef}/cardApplications`
}

export const cardApplicationApiStartCardApplication = async (baaRef: string,
    cardApplicationDto: CardApplicationDto,
    params: CardApplicationApiStartCardApplicationParams, options?: RequestInit): Promise<cardApplicationApiStartCardApplicationResponse> => {
  
  const res = await fetch(getCardApplicationApiStartCardApplicationUrl(baaRef,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      cardApplicationDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: cardApplicationApiStartCardApplicationResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as cardApplicationApiStartCardApplicationResponse
}



/**
 * @summary Fetches a card application by reference
 */
export type cardApplicationApiFetchResponse200 = {
  data: CardApplicationDocument
  status: 200
}
    
export type cardApplicationApiFetchResponseSuccess = (cardApplicationApiFetchResponse200) & {
  headers: Headers;
};
;

export type cardApplicationApiFetchResponse = (cardApplicationApiFetchResponseSuccess)

export const getCardApplicationApiFetchUrl = (baaRef: string,
    caRef: string,) => {


  

  return `/api/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}`
}

export const cardApplicationApiFetch = async (baaRef: string,
    caRef: string, options?: RequestInit): Promise<cardApplicationApiFetchResponse> => {
  
  const res = await fetch(getCardApplicationApiFetchUrl(baaRef,caRef),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: cardApplicationApiFetchResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as cardApplicationApiFetchResponse
}



/**
 * @summary Updates a card application.
 */
export type cardApplicationApiUpdateCardholderResponse200 = {
  data: void
  status: 200
}
    
export type cardApplicationApiUpdateCardholderResponseSuccess = (cardApplicationApiUpdateCardholderResponse200) & {
  headers: Headers;
};
;

export type cardApplicationApiUpdateCardholderResponse = (cardApplicationApiUpdateCardholderResponseSuccess)

export const getCardApplicationApiUpdateCardholderUrl = (baaRef: string,
    caRef: string,
    params: CardApplicationApiUpdateCardholderParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}?${stringifiedParams}` : `/api/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}`
}

export const cardApplicationApiUpdateCardholder = async (baaRef: string,
    caRef: string,
    cardApplicationDto: CardApplicationDto,
    params: CardApplicationApiUpdateCardholderParams, options?: RequestInit): Promise<cardApplicationApiUpdateCardholderResponse> => {
  
  const res = await fetch(getCardApplicationApiUpdateCardholderUrl(baaRef,caRef,params),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      cardApplicationDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: cardApplicationApiUpdateCardholderResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as cardApplicationApiUpdateCardholderResponse
}



/**
 * @summary Create cardholder benefits.
 */
export type cardApplicationApiCreateCardholderBenefitsResponse200 = {
  data: void
  status: 200
}
    
export type cardApplicationApiCreateCardholderBenefitsResponseSuccess = (cardApplicationApiCreateCardholderBenefitsResponse200) & {
  headers: Headers;
};
;

export type cardApplicationApiCreateCardholderBenefitsResponse = (cardApplicationApiCreateCardholderBenefitsResponseSuccess)

export const getCardApplicationApiCreateCardholderBenefitsUrl = (baaRef: string,
    caRef: string,) => {


  

  return `/api/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/benefits`
}

export const cardApplicationApiCreateCardholderBenefits = async (baaRef: string,
    caRef: string,
    cardholderBenefitsDto: CardholderBenefitsDto, options?: RequestInit): Promise<cardApplicationApiCreateCardholderBenefitsResponse> => {
  
  const res = await fetch(getCardApplicationApiCreateCardholderBenefitsUrl(baaRef,caRef),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      cardholderBenefitsDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: cardApplicationApiCreateCardholderBenefitsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as cardApplicationApiCreateCardholderBenefitsResponse
}



/**
 * @summary Cancels a card application
 */
export type cardApplicationApiCancelCardApplicationResponse200 = {
  data: void
  status: 200
}
    
export type cardApplicationApiCancelCardApplicationResponseSuccess = (cardApplicationApiCancelCardApplicationResponse200) & {
  headers: Headers;
};
;

export type cardApplicationApiCancelCardApplicationResponse = (cardApplicationApiCancelCardApplicationResponseSuccess)

export const getCardApplicationApiCancelCardApplicationUrl = (baaRef: string,
    caRef: string,) => {


  

  return `/api/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/cancel`
}

export const cardApplicationApiCancelCardApplication = async (baaRef: string,
    caRef: string,
    cancelApplicationDto: CancelApplicationDto, options?: RequestInit): Promise<cardApplicationApiCancelCardApplicationResponse> => {
  
  const res = await fetch(getCardApplicationApiCancelCardApplicationUrl(baaRef,caRef),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      cancelApplicationDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: cardApplicationApiCancelCardApplicationResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as cardApplicationApiCancelCardApplicationResponse
}



/**
 * @summary Changes the product of the Card application with given baaRef and caRef
 */
export type cardApplicationApiChangeProductResponse200 = {
  data: void
  status: 200
}
    
export type cardApplicationApiChangeProductResponseSuccess = (cardApplicationApiChangeProductResponse200) & {
  headers: Headers;
};
;

export type cardApplicationApiChangeProductResponse = (cardApplicationApiChangeProductResponseSuccess)

export const getCardApplicationApiChangeProductUrl = (baaRef: string,
    caRef: string,) => {


  

  return `/api/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/change-product`
}

export const cardApplicationApiChangeProduct = async (baaRef: string,
    caRef: string,
    changeApplicationProductDto: ChangeApplicationProductDto, options?: RequestInit): Promise<cardApplicationApiChangeProductResponse> => {
  
  const res = await fetch(getCardApplicationApiChangeProductUrl(baaRef,caRef),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      changeApplicationProductDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: cardApplicationApiChangeProductResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as cardApplicationApiChangeProductResponse
}



/**
 * @summary Updates the card application signatories and triggers an update of basic account applicationsignatories, too.
 */
export type cardApplicationApiUpdateCardSignatoriesResponse200 = {
  data: void
  status: 200
}
    
export type cardApplicationApiUpdateCardSignatoriesResponseSuccess = (cardApplicationApiUpdateCardSignatoriesResponse200) & {
  headers: Headers;
};
;

export type cardApplicationApiUpdateCardSignatoriesResponse = (cardApplicationApiUpdateCardSignatoriesResponseSuccess)

export const getCardApplicationApiUpdateCardSignatoriesUrl = (baaRef: string,
    caRef: string,
    params: CardApplicationApiUpdateCardSignatoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/choose-signatories?${stringifiedParams}` : `/api/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/choose-signatories`
}

export const cardApplicationApiUpdateCardSignatories = async (baaRef: string,
    caRef: string,
    signatoriesDto: SignatoriesDto,
    params: CardApplicationApiUpdateCardSignatoriesParams, options?: RequestInit): Promise<cardApplicationApiUpdateCardSignatoriesResponse> => {
  
  const res = await fetch(getCardApplicationApiUpdateCardSignatoriesUrl(baaRef,caRef,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      signatoriesDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: cardApplicationApiUpdateCardSignatoriesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as cardApplicationApiUpdateCardSignatoriesResponse
}



/**
 * @summary Prepares the card application for signing and triggers the preparation ofbasic card application for signing
 */
export type cardApplicationApiPrepareCardApplicationForSigningResponse200 = {
  data: void
  status: 200
}
    
export type cardApplicationApiPrepareCardApplicationForSigningResponseSuccess = (cardApplicationApiPrepareCardApplicationForSigningResponse200) & {
  headers: Headers;
};
;

export type cardApplicationApiPrepareCardApplicationForSigningResponse = (cardApplicationApiPrepareCardApplicationForSigningResponseSuccess)

export const getCardApplicationApiPrepareCardApplicationForSigningUrl = (baaRef: string,
    caRef: string,
    params: CardApplicationApiPrepareCardApplicationForSigningParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/confirm-pdf-details?${stringifiedParams}` : `/api/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/confirm-pdf-details`
}

export const cardApplicationApiPrepareCardApplicationForSigning = async (baaRef: string,
    caRef: string,
    params: CardApplicationApiPrepareCardApplicationForSigningParams, options?: RequestInit): Promise<cardApplicationApiPrepareCardApplicationForSigningResponse> => {
  
  const res = await fetch(getCardApplicationApiPrepareCardApplicationForSigningUrl(baaRef,caRef,params),
  {      
    ...options,
    method: 'POST'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: cardApplicationApiPrepareCardApplicationForSigningResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as cardApplicationApiPrepareCardApplicationForSigningResponse
}



/**
 * @summary Get the current available countries for a user in the specified language
 */
export type countryApiIndexResponse200 = {
  data: CountryDto[]
  status: 200
}
    
export type countryApiIndexResponseSuccess = (countryApiIndexResponse200) & {
  headers: Headers;
};
;

export type countryApiIndexResponse = (countryApiIndexResponseSuccess)

export const getCountryApiIndexUrl = (params?: CountryApiIndexParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/countries?${stringifiedParams}` : `/api/countries`
}

export const countryApiIndex = async (params?: CountryApiIndexParams, options?: RequestInit): Promise<countryApiIndexResponse> => {
  
  const res = await fetch(getCountryApiIndexUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: countryApiIndexResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as countryApiIndexResponse
}



/**
 * @summary Fetches dashboard data by basic account application reference
 */
export type dashboardApiFetchResponse200 = {
  data: DashboardDocument
  status: 200
}
    
export type dashboardApiFetchResponseSuccess = (dashboardApiFetchResponse200) & {
  headers: Headers;
};
;

export type dashboardApiFetchResponse = (dashboardApiFetchResponseSuccess)

export const getDashboardApiFetchUrl = () => {


  

  return `/api/protected/application/dashboard`
}

export const dashboardApiFetch = async ( options?: RequestInit): Promise<dashboardApiFetchResponse> => {
  
  const res = await fetch(getDashboardApiFetchUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: dashboardApiFetchResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as dashboardApiFetchResponse
}



/**
 * @summary Create a basic account application from the dashboard.
 */
export type dashboardApiCreateBasicAccountApplicationResponse200 = {
  data: string
  status: 200
}
    
export type dashboardApiCreateBasicAccountApplicationResponseSuccess = (dashboardApiCreateBasicAccountApplicationResponse200) & {
  headers: Headers;
};
;

export type dashboardApiCreateBasicAccountApplicationResponse = (dashboardApiCreateBasicAccountApplicationResponseSuccess)

export const getDashboardApiCreateBasicAccountApplicationUrl = () => {


  

  return `/api/protected/application/dashboard/basic-account`
}

export const dashboardApiCreateBasicAccountApplication = async (basicAccountApplicationDashboardDto: BasicAccountApplicationDashboardDto, options?: RequestInit): Promise<dashboardApiCreateBasicAccountApplicationResponse> => {
  
  const res = await fetch(getDashboardApiCreateBasicAccountApplicationUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      basicAccountApplicationDashboardDto,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: dashboardApiCreateBasicAccountApplicationResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as dashboardApiCreateBasicAccountApplicationResponse
}



/**
 * @summary Get all feature toggles
 */
export type featureToggleApiIndexResponse200 = {
  data: FeatureToggleApiIndex200
  status: 200
}
    
export type featureToggleApiIndexResponseSuccess = (featureToggleApiIndexResponse200) & {
  headers: Headers;
};
;

export type featureToggleApiIndexResponse = (featureToggleApiIndexResponseSuccess)

export const getFeatureToggleApiIndexUrl = () => {


  

  return `/api/feature-toggles`
}

export const featureToggleApiIndex = async ( options?: RequestInit): Promise<featureToggleApiIndexResponse> => {
  
  const res = await fetch(getFeatureToggleApiIndexUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: featureToggleApiIndexResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as featureToggleApiIndexResponse
}



/**
 * @summary Gets the container id of the injected Google Tag Manager scripts
 */
export type gtmContainerApiIndexResponse200 = {
  data: string
  status: 200
}
    
export type gtmContainerApiIndexResponseSuccess = (gtmContainerApiIndexResponse200) & {
  headers: Headers;
};
;

export type gtmContainerApiIndexResponse = (gtmContainerApiIndexResponseSuccess)

export const getGtmContainerApiIndexUrl = () => {


  

  return `/api/gtm-container`
}

export const gtmContainerApiIndex = async ( options?: RequestInit): Promise<gtmContainerApiIndexResponse> => {
  
  const res = await fetch(getGtmContainerApiIndexUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: gtmContainerApiIndexResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as gtmContainerApiIndexResponse
}



/**
 * @summary Get all industries in the specified language
 */
export type industryApiIndexResponse200 = {
  data: IndustryDto[]
  status: 200
}
    
export type industryApiIndexResponseSuccess = (industryApiIndexResponse200) & {
  headers: Headers;
};
;

export type industryApiIndexResponse = (industryApiIndexResponseSuccess)

export const getIndustryApiIndexUrl = (params?: IndustryApiIndexParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/industry?${stringifiedParams}` : `/api/industry`
}

export const industryApiIndex = async (params?: IndustryApiIndexParams, options?: RequestInit): Promise<industryApiIndexResponse> => {
  
  const res = await fetch(getIndustryApiIndexUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: industryApiIndexResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as industryApiIndexResponse
}



/**
 * @summary Get the current noga codes in the specified language
 */
export type nogaApiIndexResponse200 = {
  data: NogaCodeDto[]
  status: 200
}
    
export type nogaApiIndexResponseSuccess = (nogaApiIndexResponse200) & {
  headers: Headers;
};
;

export type nogaApiIndexResponse = (nogaApiIndexResponseSuccess)

export const getNogaApiIndexUrl = (params?: NogaApiIndexParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/noga?${stringifiedParams}` : `/api/noga`
}

export const nogaApiIndex = async (params?: NogaApiIndexParams, options?: RequestInit): Promise<nogaApiIndexResponse> => {
  
  const res = await fetch(getNogaApiIndexUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: nogaApiIndexResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as nogaApiIndexResponse
}



/**
 * @summary Get power of attorney T&C document.
 */
export type powerOfAttorneyApiIndexResponse200 = {
  data: Blob
  status: 200
}
    
export type powerOfAttorneyApiIndexResponseSuccess = (powerOfAttorneyApiIndexResponse200) & {
  headers: Headers;
};
;

export type powerOfAttorneyApiIndexResponse = (powerOfAttorneyApiIndexResponseSuccess)

export const getPowerOfAttorneyApiIndexUrl = (params: PowerOfAttorneyApiIndexParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/power-of-attorney/terms-and-condition?${stringifiedParams}` : `/api/power-of-attorney/terms-and-condition`
}

export const powerOfAttorneyApiIndex = async (params: PowerOfAttorneyApiIndexParams, options?: RequestInit): Promise<powerOfAttorneyApiIndexResponse> => {
  
  const res = await fetch(getPowerOfAttorneyApiIndexUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: powerOfAttorneyApiIndexResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as powerOfAttorneyApiIndexResponse
}



/**
 * @summary Fetches all the available product data
 */
export type productApiGetAvailableProductsResponse200 = {
  data: ProductsDto
  status: 200
}
    
export type productApiGetAvailableProductsResponseSuccess = (productApiGetAvailableProductsResponse200) & {
  headers: Headers;
};
;

export type productApiGetAvailableProductsResponse = (productApiGetAvailableProductsResponseSuccess)

export const getProductApiGetAvailableProductsUrl = () => {


  

  return `/api/products`
}

export const productApiGetAvailableProducts = async ( options?: RequestInit): Promise<productApiGetAvailableProductsResponse> => {
  
  const res = await fetch(getProductApiGetAvailableProductsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: productApiGetAvailableProductsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as productApiGetAvailableProductsResponse
}



/**
 * @summary Prepares for signing and obtains the redirect URL for the external signing service
 */
export type signingProcessApiSignFirstCardApplicationResponse200 = {
  data: string
  status: 200
}
    
export type signingProcessApiSignFirstCardApplicationResponseSuccess = (signingProcessApiSignFirstCardApplicationResponse200) & {
  headers: Headers;
};
;

export type signingProcessApiSignFirstCardApplicationResponse = (signingProcessApiSignFirstCardApplicationResponseSuccess)

export const getSigningProcessApiSignFirstCardApplicationUrl = (baaRef: string,
    caRef: string,
    params?: SigningProcessApiSignFirstCardApplicationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/sign?${stringifiedParams}` : `/api/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/sign`
}

export const signingProcessApiSignFirstCardApplication = async (baaRef: string,
    caRef: string,
    params?: SigningProcessApiSignFirstCardApplicationParams, options?: RequestInit): Promise<signingProcessApiSignFirstCardApplicationResponse> => {
  
  const res = await fetch(getSigningProcessApiSignFirstCardApplicationUrl(baaRef,caRef,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: signingProcessApiSignFirstCardApplicationResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as signingProcessApiSignFirstCardApplicationResponse
}
